import React from 'react';
import { ProviderSelect } from './ProviderSelect';
import { Option } from 'src/components/SelectBox';
import { CRM_PROVIDER_OPTIONS } from '../wizard/WizardContext';

export interface CrmProviderSelectionProps {
  onChange: (providerOption: { value: string; label: string }) => void;
  selectedProvider: Option;
  isAuthenticated?: boolean;
}

export const CrmProviderSelect: React.FC<CrmProviderSelectionProps> = ({
  onChange,
  selectedProvider,
  isAuthenticated = false,
}) => {
  const handleChange = (option: Option) => {
    onChange({
      value: option.value,
      label: option.label || option.value,
    });
  };

  return (
    <ProviderSelect
      providers={CRM_PROVIDER_OPTIONS}
      selectedProvider={selectedProvider}
      onChange={handleChange}
      isAuthenticated={isAuthenticated}
      label="CRM Provider"
      htmlFor="crm-provider"
      className="w-full max-w-xs bg-neutral-0"
    />
  );
};
